<style lang="scss">
@keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    25% {
        -webkit-transform: rotate(-45deg);
        -moz-transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        -o-transform: rotate(-45deg);
        transform: rotate(-45deg);
    }
    75% {
        -webkit-transform: rotate(-315deg);
        -moz-transform: rotate(-315deg);
        -ms-transform: rotate(-315deg);
        -o-transform: rotate(-315deg);
        transform: rotate(-315deg);
    }
    100% {
        -webkit-transform: rotate(-360deg);
        -moz-transform: rotate(-360deg);
        -ms-transform: rotate(-360deg);
        -o-transform: rotate(-360deg);
        transform: rotate(-360deg);
    }
}

@mixin spinner() {
    /*    background: transparent url(/images/loading.png) no-repeat left top;
    background-size: 24px 24px;
    width: 24px;
    height: 24px;*/
    /* margin-left: auto;
    margin-right: 10px; */
    $size: 46px;
    $stroke-width: 4px;

    -webkit-animation-fill-mode: both;
    -moz-animation-fill-mode: both;
    -ms-animation-fill-mode: both;
    -o-animation-fill-mode: both;
    animation-fill-mode: both;

    position: relative;
    width: $size;
    height: $size;
    -webkit-border-radius: 100%;
    -moz-border-radius: 100%;
    -ms-border-radius: 100%;
    -o-border-radius: 100%;
    border-radius: 100%;
    border: $stroke-width solid rgba(0, 0, 0, 0.3);

    &:after {
        position: absolute;
        content: " ";
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: $stroke-width * -1;
        -webkit-border-radius: 100%;
        -moz-border-radius: 100%;
        -ms-border-radius: 100%;
        -o-border-radius: 100%;
        border-radius: 100%;
        border: $stroke-width solid rgba(0, 0, 0, 0.8);
        border-left-color: transparent;
        border-bottom-color: transparent;
        border-right-color: transparent;
    }

    &.white {
        border-color: rgba(255, 255, 255, 0.3);

        &:after {
            border-top-color: rgba(255, 255, 255, 1);
        }
    }

    &.loading {
        -webkit-animation: spin 1s infinite linear;
        -moz-animation: spin 1s infinite linear;
        -ms-animation: spin 1s infinite linear;
        -o-animation: spin 1s infinite linear;
        animation: spin 1s infinite linear;
    }
}
.modal-loading {
    .modal-container {
        width: 200px;
        text-align: center;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        -ms-border-radius: 10px;
        -o-border-radius: 10px;
        border-radius: 10px;
        padding: 30px 20px;

        .modal-body,
        .modal-header,
        .modal-footer {
            margin: 0;
            padding: 0;
        }

        .modal-header,
        .modal-footer {
            display: none;
        }

        .spinner {
            @include spinner;
            margin: 0 auto;
        }

        .message {
            margin: 0 auto;
            margin-top: 10px;
        }
    }
}
</style>

<template>
    <modal v-model="show" class="modal-loading">
        <div slot="header"></div>
        <div slot="body">
            <div class="spinner loading"></div>
            <div class="message">
                <slot>Loading...</slot>
            </div>
        </div>
        <div slot="footer"></div>
    </modal>
</template>

<script>
import Modal from "./Modal.vue";
export default {
    model: {
        prop: "show",
        event: "change"
    },
    props: {
        show: {
            type: Boolean
        },
        message: {
            type: String,
            required: false
        }
    },
    components: {
        Modal
    }
};
</script>